"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _joi = require('@hookform/resolvers/joi');




var _joi3 = require('shared/services/validation/joi'); var _joi4 = _interopRequireDefault(_joi3);













const emailSchema = _joi4.default.object({
  email: _joi3.requiredString.call(void 0, ).messages(_joi3.makeStrErrors.call(void 0, 'Email')).contactEmail(),
})

// 2FA phone at signup, on the list the server named for this token.
const makePersonalInfoSchema = (isPhoneRequired, phonePolicy) =>
  _joi4.default.object({
    firstName: _joi3.requiredString.call(void 0, ).max(100).messages(_joi3.makeStrErrors.call(void 0, 'First name')),
    lastName: _joi3.requiredString.call(void 0, ).max(100).messages(_joi3.makeStrErrors.call(void 0, 'Last name')),
    phone: (isPhoneRequired ? _joi3.requiredString.call(void 0, ) : _joi3.optionalString.call(void 0, ))
      .messages(_joi3.makeStrErrors.call(void 0, 'Phone'))
      .contactPhone(phonePolicy),
    email: _joi3.requiredString.call(void 0, ).messages(_joi3.makeStrErrors.call(void 0, 'Email')).contactEmail(),
  })

 const getPersonalInfoResolver = (isPhoneRequired, phonePolicy = 'strict') =>
  _joi.joiResolver.call(void 0, makePersonalInfoSchema(isPhoneRequired, phonePolicy)); exports.getPersonalInfoResolver = getPersonalInfoResolver

 const emailResolver = _joi.joiResolver.call(void 0, emailSchema); exports.emailResolver = emailResolver
